// extracted by mini-css-extract-plugin
module.exports = {"subtext":"subtext__2rcFh"};